/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function Computer(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 20 19" fill="none" height={size} width={size} {...other}>
      <path
        d="M2 13H18V2H2V13ZM11 15V17H15V19H5V17H9V15H0.992003C0.860688 14.9992 0.73082 14.9725 0.60984 14.9215C0.488861 14.8704 0.379149 14.7959 0.286994 14.7024C0.194838 14.6088 0.122051 14.498 0.0728032 14.3763C0.0235556 14.2546 -0.00118396 14.1243 2.59897e-06 13.993V1.007C2.59897e-06 0.451 0.455003 0 0.992003 0H19.008C19.556 0 20 0.449 20 1.007V13.993C20 14.549 19.545 15 19.008 15H11V15Z"
        fill={color}
      />
    </svg>
  );
}

Computer.defaultProps = {
  color: "currentColor",
  size: 24,
};

Computer.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
